var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.124,
    height: 15,
    viewBox: "0 0 13.124 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play",
    "data-name": "Icon awesome-play",
    d: "M12.433,6.291,2.121.195A1.4,1.4,0,0,0,0,1.4v12.19A1.4,1.4,0,0,0,2.121,14.8L12.433,8.711a1.4,1.4,0,0,0,0-2.42Z",
    transform: "translate(0 -0.002)",
    fill: "#991f1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomePlay);
export default __webpack_public_path__ + "static/media/Icon awesome-play.01899b63bf9672c97ab7d9baf8937bb1.svg";
export { ForwardRef as ReactComponent };